import React from 'react';
import Link from 'next/link';
import clsx from 'clsx';

type SocialMediaFooterProps = Readonly<{
  layout?: 'centered' | 'spread' | 'inline';
}>;

const socialLinks = [
  { href: 'https://www.instagram.com/closerstillmedia', label: 'Instagram', icon: 'clara-social-insta' },
  { href: 'https://www.tiktok.com/@closerstillmedia', label: 'TikTok', icon: 'clara-social-tiktok' },
  { href: 'https://www.linkedin.com/company/closerstill-media', label: 'LinkedIn', icon: 'clara-social-linkedin' },
  { href: 'https://www.youtube.com/channel/UCjowou6vrd9kwc0-8TlwBPA', label: 'YouTube', icon: 'clara-social-youtube' },
] as const;

export function SocialMediaFooter({ layout = 'centered' }: SocialMediaFooterProps) {
  const isSpread = layout === 'spread';
  const isInline = layout === 'inline';

  const footerContent = (
    <>
      <ul
        aria-label="Social media"
        className={clsx(
          'flex items-center list-none p-0 m-0',
          isInline && 'max-md:contents',
          isInline ? 'md:justify-start md:gap-[var(--h16)]' : 'gap-[var(--h16)]',
          !isInline && (isSpread ? 'justify-start' : 'justify-center')
        )}
      >
        {socialLinks.map(({ href, label, icon }) => (
          <li key={label}>
            <Link
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={label}
              className="text-white inline-flex items-center justify-center transition-opacity duration-150 ease-linear hover:opacity-[0.85] active:[transform:translateY(1px)]"
            >
              <i className={`${icon} w-6 h-6 leading-none`} aria-hidden="true" />
            </Link>
          </li>
        ))}
      </ul>
      <p className="c2 book text-color-accent-selected shrink-0">© CloserStillMedia {new Date().getFullYear()}</p>
    </>
  );

  return (
    <footer
      className={clsx(
        'flex items-center justify-center',
        isSpread && 'flex-row justify-between w-full',
        isInline && 'flex-row flex-wrap md:flex-nowrap max-md:justify-between md:justify-start w-full md:gap-[4rem]',
        !isSpread && !isInline && 'flex-col gap-3 md:gap-[var(--h3)]'
      )}
    >
      {isInline ? (
        <div className="flex items-center max-md:flex-1 max-md:w-full max-md:min-w-0 max-md:justify-between md:flex-1 md:gap-[4rem]">
          {footerContent}
        </div>
      ) : (
        footerContent
      )}
    </footer>
  );
}
